'use client'
import styled from 'styled-components'
import { type ReactNode } from 'react'
import { routes } from '@shared/constants/routes'
import { AccountIcon, ArrowLeftIcon } from '@shipt/design-system-icons'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { screenSizes } from '@shipt/design-system-themes'
import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'
import { TextButton } from '@shipt/design-system-buttons'
import { TextButtonLink } from '@/features/shared/elements/Link/Buttons'
import { Stack, Row } from '@shipt/design-system-layouts'
import { BusinessBadge } from '@/features/business/components/BusinessBadge'
import { HeaderLogoLink } from '@/features/shared/components/Headers/HeaderLogoLink'

type Props = {
  children?: ReactNode | null
  className?: string
}

export const SimpleHeaderShell = ({ children, className }: Props) => (
  <SimpleHeaderWrapper className={className} contentMaxWidth>
    <HeaderLayoutContainer as="header" justify="space-between" align="center">
      {children}
    </HeaderLayoutContainer>
  </SimpleHeaderWrapper>
)

export const SimpleHeader = ({ children, className }: Props) => {
  return (
    <SimpleHeaderShell className={className}>
      <Row align="center" spacing="sm" justify="center">
        <HeaderLogoLink />
        <BusinessBadge />
      </Row>
      {children}
    </SimpleHeaderShell>
  )
}

export const SimpleHeaderWithNavigation = () => {
  const router = useSegwayRouter()
  return (
    <SimpleHeader>
      <Stack align="center">
        <HeaderButton
          variant="ghost"
          leadingIcon={ArrowLeftIcon}
          onClick={() => router.back()}
          aria-label="Go back"
        >
          Back
        </HeaderButton>
        <Spacer />
        <TextButtonLink href={routes.PROFILE.url} variant="ghost" leadingIcon={AccountIcon}>
          Account
        </TextButtonLink>
      </Stack>
    </SimpleHeader>
  )
}

const SimpleHeaderWrapper = styled(GridLayoutContainer)`
  background-color: #ffffff;
  transition: box-shadow 0.25s ease;
  box-shadow: 0 0 14px 4px rgb(0 0 0 / 8%);
`
const HeaderLayoutContainer = styled(Stack)`
  height: 4.5rem;
`
const Spacer = styled.div`
  display: inline;
  height: 1.25rem;
  width: 1rem;

  @media ${screenSizes.tablet} {
    width: 1.5rem;
  }
`
const HeaderButton = styled(TextButton)`
  pointer-events: auto;
`
